import React, {useEffect, useState, useRef, useContext} from 'react';
import '../styles/covers.styles.scss';
import Header from '../components/main-section/header.component';
import audioData from '../components/audio-data';
import AudioItemContainer from '../components/audio-item-container/audio-item-container.component';
import Footer from '../components/footer/footer.component';
import { GlobalDispatchContext, GlobalStateContext } from '../context/globalContextProvider';

import Gdpr from '../components/gdpr/gdpr.component';
import PrivacyPolicy from '../components/privacy-policy/privacy-policy.component'
import { Helmet } from "react-helmet"
import favicon from '../../static/favicon.ico';
const {
    EdmDance,
    pop,
    latin,
    jazzRockOther,
    kidsSongs,
    radio
} = audioData();

export default function Work() {
    const dispatch = useContext(GlobalDispatchContext);


    const translateRef = useRef();
    // eslint-disable-next-line
    const [speed, setSpeed] = useState(0.2);

    const [edmArray, setEdmArray] = useState(EdmDance);
    const [popArray, setPopArray] = useState(pop);
    const [latinArray, setLatinArray] = useState(latin);
    const [othersArray, setOtherArray] = useState(jazzRockOther);
    const [kidsArray, setKidsArray] = useState(kidsSongs);
    const [radioArray, setRadioArray] = useState(radio);

    // const [showSidebar, setShowSidebar] = useState(true);

    const { gdprIsOpen, policyIsOpen } = useContext(GlobalStateContext)

  

    // const handleRemoveSidebar = () => {
        
    //         if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
    //            setShowSidebar(false);
    //         } else {
    //             setShowSidebar(true);
    //         }     
    // }
    useEffect(() => {
        window.scrollTo(0, 0);

        const visited = sessionStorage.getItem('visited');
        if (!visited) {
            dispatch({
                type: 'SET_GDPR_OPEN',
                gdprIsOpen: true
            })
        }
        sessionStorage.setItem('visited', true);

        // window.addEventListener('scroll', handleRemoveSidebar)

        // return () => {
        //     window.removeEventListener('scroll', handleRemoveSidebar);
        // }
    }, [dispatch])

    useEffect(() => {
        setEdmArray(EdmDance);
        setPopArray(pop);
        setLatinArray(latin)
        setOtherArray(jazzRockOther)
        setKidsArray(kidsSongs)
        setRadioArray(radio)
    }, []);


    const emitPauseFunc = (item) => {
        reset(item, edmArray, setEdmArray);
        reset(item, popArray, setPopArray);
        reset(item, latinArray, setLatinArray);
        reset(item, othersArray, setOtherArray);
        reset(item, kidsArray, setKidsArray);
        reset(item, radioArray, setRadioArray);

      
    }


    const reset = (item, array, setState) => {
        let updatedArray = array.map(el => {
            if (el.title !== item.title) {
                el.isPlaying = false;
            }
            return el;
        })
        setState(updatedArray);
    }

  


    // const handleScroll = () => {
    //     let scroll = window.pageYOffset;
    //     let opacity = (scroll / 250).toFixed(1)
    //     opacity = 1 - (opacity * 2);
    //     translateRef.current.style.opacity = opacity;


    // }
    useEffect(() => {
        dispatch({
            type: 'SHOW_LOADING',
            isLoading: false
        })
        dispatch({
            type: 'HIDE_OVERFLOW',
            hideOverflow: false
        })
        // window.addEventListener('scroll', handleScroll)

        // return() => {
        //     window.removeEventListener('scroll', handleScroll);
        // }
    }, [dispatch])


    return (
        <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Ingrid Vocals</title>
          <link rel="icon" href={favicon} />

        </Helmet>
        <div className="work-page">
            <Header/>
            {/* {
                showSidebar &&

                    <Sidebar />
            } */}
            <div className="work"
                ref={translateRef}
                data-speed={speed}>
                <h1>WORK</h1>
                <p>INGRID HAS WORKED WITH NUMEROUS INTERNATIONAL PRODUCERS AND DJS, REACHING MORE THAN 230,000 STREAMS ON PLATFORMS.
                </p>

            </div>
            <div id="edm">
            </div>
            {
            edmArray.length > 0 && (
                <>
              
                        <AudioItemContainer 
                            array={edmArray}
                            title="EDM & DANCE"
                            link="sets/edm-dance"
                            emitPauseFunc={emitPauseFunc}
                        />
                 


                </>
            )
        }
         <div id="pop">
      </div>
            {
            popArray.length > 0 && (
                <>
                  
                        <AudioItemContainer 
                            array={popArray}
                            title="POP"
                            link="sets/pop"
                            emitPauseFunc={emitPauseFunc}

                        />
               


                </>
            )
        }
         <div id="latin">
      </div>
            {
            latinArray.length > 0 && (
                <>
                    <div id="latin">
                        <AudioItemContainer 
                            array={latinArray}
                            title="LATIN"
                            link="sets/latin"
                            emitPauseFunc={emitPauseFunc}

                        />
                    </div>


                </>
            )
        }
         <div id="others">
      </div>
            {
            othersArray.length > 0 && (
                <>

                    <AudioItemContainer 
                        array={othersArray}
                        title="JAZZ, ROCK & OTHERS"
                        link="sets/jazz-rock-others"
                        emitPauseFunc={emitPauseFunc}

                      />

                </>
            )
        }
         <div id="kids">
      </div>
            {
            kidsArray.length > 0 && (
                <>
                    <AudioItemContainer 
                        array={kidsArray}
                        title="KIDS"
                        link="sets/kid-songs"
                        emitPauseFunc={emitPauseFunc}

                    />
                </>
            )
        }
      <div id="jingles">
      </div>
            {
            radioArray.length > 0 && (
                <>
                    
                    <AudioItemContainer 
                        array={radioArray}
                        title="JINGLES"
                        link=""
                        emitPauseFunc={emitPauseFunc}

                        />
                 
                    

                </>
            )
        } 
        
        </div>
        <Footer/>
        {
                gdprIsOpen && <Gdpr />
            }
            {
                policyIsOpen && <PrivacyPolicy />
            }
        </>
        
       
    )
}
